import { render, staticRenderFns } from "./PasswordBot.vue?vue&type=template&id=a0c72d02&scoped=true&lang=html&"
import script from "./PasswordBot.vue?vue&type=script&lang=js&"
export * from "./PasswordBot.vue?vue&type=script&lang=js&"
import style0 from "./PasswordBot.vue?vue&type=style&index=0&id=a0c72d02&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c72d02",
  null
  
)

export default component.exports